export var DefiScoreTokenList = [
    "bat",
    "dai",
    "eth",
    "knc",
    "lend",
    "link",
    "mkr",
    "rep",
    "snx",
    "susd",
    "tusd",
    "usdc",
    "usdt",
    "wbtc",
    "zrx",
];
var DefiScoreProtocolList = [
    "compound",
    "dydx",
    "ddex",
    "aave",
    "mcd",
];
//# sourceMappingURL=defiScore.js.map